import styled from 'styled-components';

// Components
import { Typography } from '../../display/Typography';

/**
 * Caja común de los toasts.
 *
 * ── Por qué existe ─────────────────────────────────────────────────────────
 *
 * Los toasts nacieron copiando la misma caja, y tres de las cuatro copias se
 * quedaron con `width` y `height` FIJOS (`33.8rem` × `6.6rem`). Mientras el
 * texto cupiera en una línea no se notaba; en cuanto no cabe —un mensaje largo,
 * o el aviso de fichero guardado, que lleva título MÁS nombre de fichero— el
 * contenido no cabe en el alto reservado y sale aplastado contra los bordes.
 *
 * `ErrorToast` era el único que ya lo había resuelto (`min-width`/`max-width` +
 * `min-height`). Esto promueve SU solución a caja común: el arreglo vive en un
 * sitio y las copias dejan de poder divergir, que es lo que causó el problema.
 *
 * ── La regla ───────────────────────────────────────────────────────────────
 *
 * El alto lo decide el CONTENIDO. `min-height` fija el mínimo para que un toast
 * de una línea siga teniendo el cuerpo de siempre, y nunca el máximo. El ancho
 * crece hasta un tope legible en vez de forzar el texto a partirse.
 *
 * `max-width` (42rem = 420 px con la raíz al 62.5 %) entra de sobra en la
 * tablet incluso en vertical, que es el caso más estrecho que soporta la app.
 */
export const ToastShell = styled.div`
  min-width: ${({ theme }) => theme.sizes.modalMinWidth};
  max-width: 42rem;
  min-height: 6.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: 1rem 1rem 1rem 2rem;
  box-shadow: ${({ theme }) => theme.shadows.toast};
`;

/**
 * Texto de un toast.
 *
 * `overflow-wrap` corta una palabra sin espacios —un nombre de fichero, una
 * URL, un ROID— antes de dejar que desborde la caja. Sin esto, el `max-width`
 * no sirve de nada frente a un token largo.
 */
export const ToastText = styled(Typography)`
  line-height: 1.4;
  overflow-wrap: break-word;
  word-break: break-word;
`;
